var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1331 9.05866C10.0498 9.05033 9.9498 9.05033 9.85814 9.05866C7.8748 8.99199 6.2998 7.36699 6.2998 5.36699C6.2998 3.32533 7.9498 1.66699 9.9998 1.66699C12.0415 1.66699 13.6998 3.32533 13.6998 5.36699C13.6915 7.36699 12.1165 8.99199 10.1331 9.05866Z",
    stroke: "#1b1d52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.9666 12.133C3.94993 13.483 3.94993 15.683 5.9666 17.0247C8.25827 18.558 12.0166 18.558 14.3083 17.0247C16.3249 15.6747 16.3249 13.4747 14.3083 12.133C12.0249 10.608 8.2666 10.608 5.9666 12.133Z",
    stroke: "#1b1d52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.86f9cff9f28bf82a54f7cfc5bb600e7a.svg";
export { ForwardRef as ReactComponent };